import { utils } from '@kurtosys/ksys-app-template';
const ksysCollapsingMarginFixClassName = 'ksys-collapsing-margin-fix';
export function splitApp(element: HTMLElement, remainingPageHeight: number, pageHeight: number) {
	injectStyles();
	const size = utils.layout.getHtmlElementSize(element);
	const disclaimersWrapper = getElementMetaFromSelector(element, '[data-selector="overview-disclaimers-wrapper"]');
	const disclaimers = getElementsMetaFromSelector(disclaimersWrapper.element, '[data-selector="overview-disclaimer-wrapper"]');
	const cardHeader = getElementMetaFromSelector(element, 'header[data-selector="base-card-header"]');
	const height = size.height;
	const calculatedHeight = (cardHeader.size.height || 0) + (disclaimersWrapper.size.height || 0);
	const margin = (height || 0) - calculatedHeight;

	const instances: any[] = [];
	let instance: { height: number, heights: number[], start: number, limit: number, hasCardHeader: boolean } = {
		heights: [(cardHeader.size.height || 0), margin],
		height: (cardHeader.size.height || 0) + margin,
		start: 0,
		limit: 0,
		hasCardHeader: true,
	};

	let maxHeight = remainingPageHeight > 0 ? remainingPageHeight : pageHeight;
	// If no rows are present then we are just going to go to a new page
	if (instance.height > maxHeight) {
		maxHeight = pageHeight;
	}
	disclaimers.forEach((disclaimer, disclaimerIndex) => {
		const disclaimerHeight = (disclaimer.size.height || 0);
		// We are on the first disclaimer and the card header, margin is too big to allow a disclaimer in,
		// so we bump it to a full page to not have an empty header displaying
		if (disclaimerIndex === 0 && maxHeight !== pageHeight && (disclaimerHeight + instance.height) > maxHeight) {
			maxHeight = pageHeight;
		}
		if (disclaimerHeight + instance.height <= maxHeight) {
			instance.heights.push(disclaimerHeight);
			instance.height += disclaimerHeight;
			instance.limit++;
		}
		else {
			instances.push(instance);
			// If there was a remainingPageHeight we now move onto a new page
			maxHeight = pageHeight;
			instance = {
				heights: [margin, disclaimerHeight],
				height: margin + disclaimerHeight,
				start: disclaimerIndex,
				limit: 1,
				hasCardHeader: false,
			};
		}
	});
	if (instance && instance.limit > 0) {
		instances.push(instance);
	}
	return instances;
}

function getElementMetaFromSelector(parent: HTMLElement | null, selector: string) {
	const element = parent && parent.querySelector(selector);
	return getElementMeta(element);
}

function getElementsMetaFromSelector(parent: HTMLElement | null, selector: string) {
	const elements = parent && parent.querySelectorAll(selector);
	return Array.from(elements || []).map(getElementMeta);
}

function getElementMeta(element: Element | HTMLElement | null) {
	if (element) {
		const htmlElement = element as HTMLElement;
		if (!htmlElement.classList.contains(ksysCollapsingMarginFixClassName)) {
			htmlElement.classList.add(ksysCollapsingMarginFixClassName);
		}
	}
	return {
		element: element as HTMLElement,
		size: (element && utils.layout.getHtmlElementSize(element as HTMLElement)) || {},
	};
}

function injectStyles() {
	const id = 'app-split-styles';
	const existing = document.querySelector(`#${ id }`);
	if (!existing) {
		const style = document.createElement('style');
		style.type = 'text/css';
		style.id = id;
		style.appendChild(
			document.createTextNode(`
				.${ ksysCollapsingMarginFixClassName } {
					overflow: auto;
				}
			`),
		);
		const body = document.querySelector('body');
		if (body) {
			body.appendChild(style);
		}
	}
}